import {
  FormControlLabel,
  FormControlLabelProps,
  Radio,
  useRadioGroup,
  useTheme,
} from '@mui/material';
import { MdCheckCircle } from '@teamworksdev/icons';

export function LabeledRadioChip({
  value,
  label,
  disabled = false,
}: Omit<FormControlLabelProps, 'control'>) {
  const {
    palette: { info, greyscaleLight },
  } = useTheme();
  const radioGroup = useRadioGroup();
  const checked = radioGroup && radioGroup.value === value;

  return (
    <FormControlLabel
      checked={checked}
      value={value}
      disabled={disabled}
      control={
        <Radio
          disableRipple
          color="default"
          checkedIcon={<MdCheckCircle size={14} color={info.main} />}
          icon={
            <div
              className="h-[14px] w-[14px] rounded"
              style={{
                backgroundColor: greyscaleLight[100],
                borderWidth: 1,
                borderColor: greyscaleLight[300],
                borderRadius: '1000px',
              }}
            />
          }
        />
      }
      label={label}
      sx={{
        marginX: '0px',
        paddingX: '12px',
        borderRadius: '1000px',
        borderWidth: '1px',
        backgroundColor: checked ? info.lighter : greyscaleLight[25],
        borderColor: checked ? info.light : greyscaleLight[200],
        '& .MuiFormControlLabel-label': {
          fontSize: '12px',
          fontWeight: 500,
          color: checked ? info.main : greyscaleLight[700],
        },
        '& .MuiRadio-root': { padding: '0px 4px 0px 0px' },
      }}
    />
  );
}
